import Loading from '../../../Common/Loading';
import { ByAgeAnual } from './ByAgeAnual';
import { ByAgeMonth } from './ByAgeMonth';
import { ByGenderAnual } from './ByGenderAnual';
import { ByGenderMonth } from './ByGenderMonth';
import { ByPeopleTypeAnual } from './ByPeopleTypeAnual';
import { ByPeopleTypeMonth } from './ByPeopleTypeMonth';
import { ByProfessionAnual } from './ByProfessionAnual';
import { ByProfessionMonth } from './ByProfessionMonth';
import { BySkinColorAnual } from './BySkinColorAnual';
import { BySkinColorMonth } from './BySkinColorMonth';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';
import React, { memo } from 'react';

const Graphs = memo(() => (
    <>
        <div className="charts-side-by-side-dashboards">
            <ByPeopleTypeAnual />
            <ByPeopleTypeMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <ByGenderAnual />
            <ByGenderMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <ByAgeAnual />
            <ByAgeMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <BySkinColorAnual />
            <BySkinColorMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <ByProfessionAnual />
            <ByProfessionMonth />
        </div>
    </>
));

export const Charts = () => {
    const { isLoading } = useProfileChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Graphs />
        </>
    );
};
